interface TitleBarProps {
  title: string;
}

const TitleBar = ({ title }: TitleBarProps): JSX.Element => {
  return (
    <div className="sticky top-0 flex items-start h-10 w-full bg-[#4c65aa] font-bold text-white text-base leading-10 px-5 z-1">
      {title}
    </div>
  );
};

export default TitleBar;
